import React from "react";
import DespliegueInfo from "./DespliegueInfo/DespliegueInfo";
import MenuLat from "./InfoMenuLat/MenuLat";
import MenuSup from "./InfoMenuSup/MenuSup";
import ResultadoBus from "../Buscador/ResultadoBus";
import BusquedaAva from "../Buscador/BusquedaAva";
import MasInformacion from "../Contenido/Inicio/MasInformacion";
import normatecaStore from "../../stores/normatecaStore";

export default function Contenido(){
    // store - zuntand
    const { opcMenu } =
     normatecaStore((state) =>( { 
        opcMenu: state.opcMenu,
   })); 
    return (
        <div key={"divCon"}>
            {opcMenu==="menuNav" || opcMenu==="menuLat"? 
                <div className="divInfo2">
                    <MenuLat/>
                    <DespliegueInfo/>
                </div>
            : null
            }
            {opcMenu==="menuMat" || opcMenu==="menuSup" ? 
                <div className="divInfo">
                    <MenuSup/>
                    <DespliegueInfo/> 
                </div>
            : null
            }
            {opcMenu==="bus" || opcMenu==="busAva"? 
                <div className="divInfo">
                    <ResultadoBus/>
                    <DespliegueInfo/>
                </div>
            : null
            }
            {opcMenu==="busAvaOpc" ? 
                <div className="divInfo">
                    <BusquedaAva/>
                </div>
            : null
            }
            {opcMenu==="masInfo" ? 
                <div className="divInfo">
                    <MasInformacion/>
                </div>
            : null
            }
          {/*   {opcContenido===""? </> : null} */}
        </div>
    )
}